import { SortOrder } from '@constants/common.constants';

import { HISTORICAL_DOCUMENTS_SORT_FIELDS } from './documents.types';

export const HISTORICAL_DOCUMENTS_INITIAL_PAGE_NUMBER = 0;

export const HISTORICAL_DOCUMENTS_DEFAULT_SORT_COLUMN =
    HISTORICAL_DOCUMENTS_SORT_FIELDS.UPLOADED_DATE;

export const HISTORICAL_DOCUMENTS_DEFAULT_SORT_ORDER = SortOrder.DESC;
